import { Controller } from 'react-hook-form'
import * as z from 'zod'
import { ScoreRadio } from '~/@mid_ui-form/score-radio/ScoreRadio'
import { ScoreRadioGroup } from '~/@mid_ui-form/score-radiu-group/ScoreRadioGroup'
import { Text } from '~/@mid_ui/typography/Text'
import { FormStep } from '~/@pages_onboarding/investor-analysis/_analysis-form/FormStep'
import { StepTitle } from '~/@pages_onboarding/investor-analysis/_analysis-form/StepTitle'
import { useFormStepUnsophisticated } from '../../form-step-unsophisticated/useFormStepUnsophisticated'
import { useQuestionsV1 } from '../../../questions'

const step5Schema = z.object({
  educationLevel: z.object({
    value: z.enum([
      'basicEducation',
      'vocationalEducation',
      'higherEducation',
      'professionalQualification',
    ]),
    score: z.number(),
  }),
})

export type Step5Data = z.infer<typeof step5Schema>

export function Step5() {
  const { onStepCompleted, formData } = useFormStepUnsophisticated()
  const { unsophisticated: unsophisticatedQuestions } = useQuestionsV1()

  return (
    <FormStep
      defaultValues={formData}
      schema={step5Schema}
      onStepCompleted={onStepCompleted}
      render={({ control }) => (
        <>
          <StepTitle>
            {unsophisticatedQuestions.educationLevel.question.label}
          </StepTitle>
          <Text className="font-medium">
            V rámci regulácie a dohľadu Národnej banky Slovenska prosíme o
            vyplnenie informácii nižšie.
          </Text>
          <Controller
            control={control}
            name="educationLevel"
            render={({ field }) => (
              <ScoreRadioGroup
                value={field.value}
                onValueChange={field.onChange}>
                {Object.entries(
                  unsophisticatedQuestions.educationLevel.answers
                ).map(([value, answer]) => (
                  <ScoreRadio
                    key={value}
                    score={answer.score}
                    value={value}
                    label={answer.label}
                  />
                ))}
              </ScoreRadioGroup>
            )}
          />
        </>
      )}
    />
  )
}
